import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://8daade1dfafee15d959f472d11672661@o4510712801067008.ingest.us.sentry.io/4510964652179456",
    debug: false,
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
        }),
    ],
    // Tracing & Network mapping
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    tracePropagationTargets: ["localhost", "xbqjufvjleparnztooia.supabase.co"],

    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

export { Sentry };
